<template>
  <header class="topbar">
    <button class="menu-toggle" @click="$emit('toggle-sidebar')">☰</button>
    <div class="brand-title">
      <strong>Gestion Total</strong>
      <small v-if="company">{{ company.name }}</small>
    </div>
    <div class="topbar-actions">
      <span v-if="renewalText" class="gt-pill renewal">{{ renewalText }}</span>
      <span v-if="branch" class="gt-pill">{{ branch.name }}</span>
      <router-link class="profile-link" to="/cuenta">
        <span class="avatar">{{ initials }}</span>
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'TopBar',
  computed: {
    company() { return this.$store.state.context?.company; },
    branch() { return this.$store.state.context?.branch; },
    subscription() { return this.$store.state.context?.subscription; },
    renewalText() {
      const days = this.subscription?.days_remaining;
      if (days === null || days === undefined) return '';
      if (this.subscription?.status === 'trialing') return `Prueba: ${days} dias`;
      return `Renueva en ${days} dias`;
    },
    initials() {
      const name = this.$store.state.user?.name || 'GT';
      return name.split(' ').map((item) => item[0]).join('').substring(0, 2).toUpperCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  position: fixed;
  inset: 0 0 auto 0;
  height: 4.5rem;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1.25rem;
  background: rgba(255,255,255,.82);
  border-bottom: 1px solid var(--gt-border);
  backdrop-filter: blur(16px);
}
.menu-toggle {
  border: 0;
  background: var(--gt-primary-soft);
  color: var(--gt-primary);
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 999px;
  cursor: pointer;
  font-size: 1.25rem;
}
.brand-title { min-width: 0; }
strong { display: block; font-size: 1.05rem; }
small { display: block; color: var(--gt-muted); margin-top: .1rem; }
.topbar-actions { display: flex; align-items: center; gap: .75rem; }
.renewal { background: #fff7e8; color: #99600f; }
.profile-link { text-decoration: none; }
.avatar {
  width: 2.65rem;
  height: 2.65rem;
  border-radius: 999px;
  background: var(--gt-primary);
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 900;
}
@media (max-width: 720px) {
  .brand-title small { max-width: 9rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .renewal { display: none; }
}
</style>
